import { get, patch } from 'store/http/httpAction';
import { SET_OBJECT_NAME, SET_SEARCH_KEY, SET_SEARCH_RESULTS, SET_SELECTED_ACCOUNT_ID, RESET } from './actionTypes';

const setObjectName = name => ({
  type: SET_OBJECT_NAME,
  payload: { name },
});

export const setSearchKey = searchKey => ({
  type: SET_SEARCH_KEY,
  payload: { searchKey }
});

const setSearchResults = results => ({
  type: SET_SEARCH_RESULTS,
  payload: { results }
});

export const setSelectedAccountId = accountId => ({
  type: SET_SELECTED_ACCOUNT_ID,
  payload: { accountId }
});

export const reset = () => ({
  type: RESET,
});

export const fetchOpportunitiesDetail = id => dispatch => get(`/admin/opportunities/${id}`, {}, dispatch).then(data => {
  if (data && data.data) {
    dispatch(setObjectName(data.data.name));
  }
});

export const searchAccounts = searchKey => dispatch => get('/admin/accounts/search/opportunity-attach', { search: searchKey }, dispatch).then(data => {
  if (data) {
    dispatch(setSearchResults(data));
    // Set the first data as default selected value
    if (data.index && _.isArray(data.index.data) && !_.isEmpty(data.index.data)) {
      dispatch(setSelectedAccountId(data.index.data[0].id));
    }
  }
});

export const patchAttachAccount = (objectType, objectId, selectedAccountId, cb) => dispatch => patch(`/admin/${objectType}/${objectId}/attach-account/${selectedAccountId}`, {}, dispatch).then(data => {
  if (data && data.data) {
    cb();
  }
});



// WEBPACK FOOTER //
// ./src/views/AttachAccount/flow/action.js